<template>
  <div class="fleet-info">
    <div class="d-flex relative">
      <div class="flex-grow-1">
        <span class="text-muted">{{ $t('global.object.licensePlate') }}</span>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton width="100px" />
          </template>
          <p>{{ vehicle?.license_plate ?? '-' }}</p>
        </b-skeleton-wrapper>
      </div>
      <div v-if="driver" class="flex-grow-1">
        <span class="text-muted">{{ $t('global.object.driverName') }}</span>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton width="100px" />
          </template>
          <p>
            {{ driver?.name ?? '-' }}
          </p>
        </b-skeleton-wrapper>
      </div>
    </div>
    
    <div v-if="note" class="flex-grow-1">
      <span class="text-muted">{{ $t('global.object.note') }}</span>
      <b-skeleton-wrapper :loading="isLoading">
        <template #loading>
          <b-skeleton width="100px" />
        </template>
        <p>
          {{ note }}
        </p>
      </b-skeleton-wrapper>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    driver: {
      type: Object,
      default: null,
    },
    vehicle: {
      type: Object,
      default: null,
    },
    note: {
      type: String,
      default: null,
    }
  },
  computed: {
    isLoading() {
      return this.loading
    }
  }
}
</script>

<style lang="scss" scoped>
.fleet-info {
  position: relative;

  > div {
    flex: 1;
  }

  p {
    .text-muted {
      display: inline-block;
    }
  }

  .extra-info {
    font-style: italic;
  }

  .mc-fa {
    position: absolute;
    left: 0;
    top: 0;
    font-size: 28px;
    padding: 10px;
    background-color: $mep-secondary-100;
    border-radius: 100%;
    display: block;
  }
}
</style>